import React, { useContext, Fragment } from 'react'
import { useQuery } from '@apollo/client'
import { DailyMonitoringFiltersContext } from '../../../../context/DailyMonitoringFiltersContext'
import AutocompleteComponent from '../../../../components/filters/AutocompleteComponent'
import { GET_STATES } from '../../../../queries'

export default function States (): JSX.Element {
  const { filters, setFilters } = useContext(DailyMonitoringFiltersContext)
  const { loading, error, data } = useQuery(GET_STATES)

  if (loading) return <p>Loading...</p>
  if (error) return <p>Error :(</p>
  if (!data.ordersAggs.aggregations.states) return <p>No data found</p>

  const states: Array<string> = []
  data.ordersAggs.aggregations.states.buckets.map((state: any) => {
    states.push(state.key)
  })

  const onChange = (value: string[]) => {
    setFilters({
      states: value
    })
  }

  const typographLabel = 'Estado'

  return (
    <Fragment>
      <AutocompleteComponent
        labelValue={typographLabel}
        data={states}
        defaultValues={filters.states}
        onChange={onChange}
      />
    </Fragment>
  )
}
